import { END_URL } from "../../constants/endUrl";
import { HttpError } from "../../ServerError/HttpError";
import { httpGet, httpPost } from "../httpMethods";

export const SubChildCategoryListService = () => {
	const SubChildCategoryList = async (payload) => {
		try {
			const response = await httpGet(`${END_URL.SubChildCategoryList}`, payload);
			return response;
		} catch (error) {
			if (error instanceof HttpError) {
				console.error(
					`HTTP Error: ${error.message} (Status Code: ${error.statusCode})`
				);
				if (error.statusCode === 401) {
					console.warn("Unauthorized. Redirecting to login.");
				}
			} else {
				console.error("An unknown error occurred:", error);
			}
			throw error;
		}
	};
	return {
		SubChildCategoryList,
	};
};
